<div
  class="bottom-menu-modal"
  #modal
  [ngStyle]="{
    marginTop: marginTop + 'px',
  }"
>
  <button class="close-btn" (click)="closed.emit()" *ngIf="showCloseButton">
    <i class="material-icons">close</i>
  </button>
  <div class="drag-wrapper d-block d-lg-none" #dragPointer>
    <div class="drag-pointer"></div>
  </div>
  <div
    class="bottom-menu-modal-body"
    [ngStyle]="{
    height: 'calc(100vh - ' + (marginTop + 22) + 'px)',
    overflowY: translateY > 0 ? 'hidden' : 'auto',
  }"
  >
    <ng-template #container></ng-template>
  </div>
</div>

<div class="bottom-modal-overlay" #overlay></div>
